/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges, signal} from '@angular/core';
import template from './role-analysis-page.component.html';

import {loadRoleAnalysisUsers} from './role-commons';
import {TeamApiService} from '../team/team-api.service';
import {UserApiService} from '../user/user-api.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {APP_SHARED} from '../../common/app-shared';
import {UIRouterModule} from '@uirouter/angular';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule],
  selector: 'adn-role-analysis-page',
  template
})
export class RoleAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  @Input() isNew: boolean;

  private readonly usersState = signal<any[]>([]);
  private readonly loadingState = signal(false);
  private readonly loadedState = signal(false);
  get users(): any[] { return this.usersState(); }
  set users(value: any[]) { this.usersState.set(value); }
  get loading(): boolean { return this.loadingState(); }
  set loading(value: boolean) { this.loadingState.set(value); }
  get loaded(): boolean { return this.loadedState(); }
  set loaded(value: boolean) { this.loadedState.set(value); }

  constructor(
    private readonly teamApi: TeamApiService,
    private readonly userApi: UserApiService,
    @Inject(LocalNetworkProfile) private LocalNetworkProfile: any
  ) {
  }

  get displayLoaded(): boolean {
    return this.loaded;
  }

  ngOnChanges(): void {
    this.refreshUsers();
  }

  trackByUserId(_index: number, user: any): string {
    return user.id;
  }

  trackByTeamId(_index: number, team: any): string {
    return team.id || team.name;
  }

  private refreshUsers(): void {
    if (this.isNew || !this.model?.id) {
      this.users = [];
      this.loading = false;
      this.loaded = true;
      return;
    }

    this.loading = true;
    this.loaded = false;
    loadRoleAnalysisUsers(this.model, this.teamApi, this.userApi, this.LocalNetworkProfile).then((users) => {
      this.users = users;
      this.loading = false;
      this.loaded = true;
    }).catch(() => {
      this.users = [];
      this.loading = false;
      this.loaded = true;
    });
  }
}
